import React, { useState } from 'react';
import Header from '../components/Header';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

interface Trace {
  id: number;
  titre: string;
  distance: string;
  denivele: string;
  duree: string;
  difficulte: 'facile' | 'modere' | 'difficile' | 'expert';
  type: 'route' | 'gravel';
  surface: string;
  stravaUrl: string;
  gpxUrl: string;
  image: string;
  mapPreview: string;
  description: string;
  pointsForts: string[];
  featured?: boolean;
}

const TracesGPX: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<'all' | 'route' | 'gravel'>('all');
  const [difficultyFilter, setDifficultyFilter] = useState<string>('all');
  const [expandedTrace, setExpandedTrace] = useState<number | null>(null);

  const traces: Trace[] = [
    {
      id: 1,
      titre: 'Vallée de Chevreuse - Classic',
      distance: '65 km',
      denivele: '750 m',
      duree: '2h30 - 3h',
      difficulte: 'modere',
      type: 'route',
      surface: '100% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example1',
      gpxUrl: '#',
      image: '/GPX/Vallée de Chevreuse - Classic.png',
      mapPreview: '/GPX/Vallée de Chevreuse - Classic.png',
      description: 'Le parcours incontournable des cyclistes parisiens. Traversez les villages pittoresques de la vallée et profitez de routes vallonnées avec peu de circulation.',
      pointsForts: ['Château de Dampierre', 'Côte de Port-Royal', 'Villages authentiques'],
      featured: true
    },
    {
      id: 2,
      titre: 'Forêt de Rambouillet',
      distance: '55 km',
      denivele: '450 m',
      duree: '2h - 2h30',
      difficulte: 'facile',
      type: 'route',
      surface: '100% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example2',
      gpxUrl: '#',
      image: '/GPX/FORET DE RAMBOUILLET.png',
      mapPreview: '/GPX/FORET DE RAMBOUILLET.png',
      description: 'Parcours forestier idéal pour une sortie tranquille. Routes ombragées en été et paysages variés tout au long de l\'année.',
      pointsForts: ['Forêt domaniale', 'Étangs', 'Routes calmes']
    },
    {
      id: 3,
      titre: 'Boucle du Vexin - Challenge',
      distance: '95 km',
      denivele: '1100 m',
      duree: '3h30 - 4h30',
      difficulte: 'difficile',
      type: 'route',
      surface: '100% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example3',
      gpxUrl: '#',
      image: '/GPX/boucle de vexin.png',
      mapPreview: '/GPX/boucle de vexin.png',
      description: 'Pour les grimpeurs ! Ce parcours vous emmène au cœur du Vexin français avec ses côtes mythiques et ses panoramas exceptionnels.',
      pointsForts: ['Côte de Vétheuil', 'Vue sur la Seine', 'Villages perchés'],
      featured: true
    },
    {
      id: 4,
      titre: 'Tour de Versailles',
      distance: '45 km',
      denivele: '350 m',
      duree: '1h30 - 2h',
      difficulte: 'facile',
      type: 'route',
      surface: '100% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example4',
      gpxUrl: '#',
      image: '/GPX/Tour de Versailles.png',
      mapPreview: '/GPX/Tour de Versailles.png',
      description: 'Parfait pour une sortie matinale ou une reprise. Ce parcours plat autour de Versailles est idéal pour travailler l\'endurance.',
      pointsForts: ['Château de Versailles', 'Parc', 'Parcours plat']
    },
    {
      id: 5,
      titre: 'La Chevreuse Épique',
      distance: '120 km',
      denivele: '1500 m',
      duree: '4h30 - 5h30',
      difficulte: 'expert',
      type: 'route',
      surface: '100% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example5',
      gpxUrl: '#',
      image: '/GPX/La Chevreuse Épique.png',
      mapPreview: '/GPX/La Chevreuse Épique.png',
      description: 'Le parcours ultime pour les cyclistes aguerris. Enchaînez toutes les difficultés de la région dans une boucle mémorable.',
      pointsForts: ['Toutes les côtes', 'Parcours complet', 'Défi personnel']
    },
    {
      id: 6,
      titre: 'Forêt de Meudon - Gravel',
      distance: '35 km',
      denivele: '400 m',
      duree: '1h30 - 2h',
      difficulte: 'modere',
      type: 'gravel',
      surface: '60% chemins, 40% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example6',
      gpxUrl: '#',
      image: '/GPX/Forêt de Meudon - Gravel.png',
      mapPreview: '/GPX/Forêt de Meudon - Gravel.png',
      description: 'Découvrez les sentiers secrets de la forêt de Meudon. Un mix parfait entre chemins forestiers et liaison asphalte.',
      pointsForts: ['Observatoire de Meudon', 'Single tracks', 'Nature proche de Paris'],
      featured: true
    },
    {
      id: 7,
      titre: 'Bois de Boulogne Mix',
      distance: '25 km',
      denivele: '150 m',
      duree: '1h - 1h15',
      difficulte: 'facile',
      type: 'gravel',
      surface: '70% chemins, 30% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example7',
      gpxUrl: '#',
      image: '/GPX/Bois de Boulogne Mix.png',
      mapPreview: '/GPX/Bois de Boulogne Mix.png',
      description: 'Idéal pour débuter en gravel ! Ce parcours urbain alterne entre allées du bois et petits chemins accessibles.',
      pointsForts: ['Accessible', 'Proche centre', 'Parfait débutant']
    },
    {
      id: 8,
      titre: 'Vallée de la Bièvre - Explorer',
      distance: '48 km',
      denivele: '550 m',
      duree: '2h - 2h30',
      difficulte: 'modere',
      type: 'gravel',
      surface: '55% chemins, 45% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example8',
      gpxUrl: '#',
      image: '/GPX/Vallée de la Bièvre - Explorer.png',
      mapPreview: '/GPX/Vallée de la Bièvre - Explorer.png',
      description: 'Suivez le cours de la Bièvre à travers les forêts et villages. Un parcours varié avec quelques passages techniques.',
      pointsForts: ['Rivière Bièvre', 'Patrimoine', 'Passages techniques']
    },
    {
      id: 9,
      titre: 'Chevreuse Gravel Adventure',
      distance: '62 km',
      denivele: '750 m',
      duree: '2h45 - 3h30',
      difficulte: 'difficile',
      type: 'gravel',
      surface: '65% chemins, 35% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example9',
      gpxUrl: '#',
      image: '/GPX/Chevreuse Gravel Adventure.png',
      mapPreview: '/GPX/Chevreuse Gravel Adventure.png',
      description: 'La version gravel de notre classique ! Explorez des chemins que vous n\'avez jamais vus en vélo de route.',
      pointsForts: ['Chemins secrets', 'Vallée sauvage', 'Aventure garantie']
    },
    {
      id: 10,
      titre: 'Trans-Forêts Île-de-France',
      distance: '85 km',
      denivele: '900 m',
      duree: '4h - 5h',
      difficulte: 'expert',
      type: 'gravel',
      surface: '75% chemins, 25% asphalte',
      stravaUrl: 'https://www.strava.com/routes/example10',
      gpxUrl: '#',
      image: '/GPX/Trans foret ile de france.png',
      mapPreview: '/GPX/Trans foret ile de france.png',
      description: 'L\'épopée ultime en gravel ! Reliez plusieurs forêts franciliennes dans un parcours d\'aventure inoubliable.',
      pointsForts: ['Multi-forêts', 'Autonomie', 'Exploration totale']
    }
  ];

  const getDifficultyColor = (diff: string) => {
    switch (diff) {
      case 'facile': return 'bg-green-500';
      case 'modere': return 'bg-yellow-500';
      case 'difficile': return 'bg-orange-500';
      case 'expert': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  const getDifficultyLabel = (diff: string) => {
    switch (diff) {
      case 'facile': return 'Facile';
      case 'modere': return 'Modéré';
      case 'difficile': return 'Difficile';
      case 'expert': return 'Expert';
      default: return diff;
    }
  };

  const filteredTraces = traces.filter(trace => {
    const typeMatch = activeFilter === 'all' || trace.type === activeFilter;
    const diffMatch = difficultyFilter === 'all' || trace.difficulte === difficultyFilter;
    return typeMatch && diffMatch;
  });

  const featuredTraces = traces.filter(t => t.featured);

  const stats = {
    totalTraces: traces.length,
    totalKm: traces.reduce((acc, t) => acc + parseInt(t.distance), 0),
    routeTraces: traces.filter(t => t.type === 'route').length,
    gravelTraces: traces.filter(t => t.type === 'gravel').length
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-24 md:pt-32 pb-16 md:pb-24 overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-orange-500/20 text-orange-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
              Départ : 26 Bd Henri Sellier, Suresnes
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Traces GPX<br />
              <span className="text-orange-400">Route & Gravel</span>
            </h1>

            <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-10">
              Découvrez nos itinéraires soigneusement sélectionnés au départ de la boutique.
              Téléchargez les fichiers GPX et partez explorer les plus belles routes d'Île-de-France.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                <p className="text-3xl font-bold text-white">{stats.totalTraces}</p>
                <p className="text-slate-400 text-sm">Parcours</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                <p className="text-3xl font-bold text-white">{stats.totalKm}+</p>
                <p className="text-slate-400 text-sm">Kilomètres</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                <p className="text-3xl font-bold text-orange-400">{stats.routeTraces}</p>
                <p className="text-slate-400 text-sm">Traces Route</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                <p className="text-3xl font-bold text-orange-400">{stats.gravelTraces}</p>
                <p className="text-slate-400 text-sm">Traces Gravel</p>
              </div>
            </div>
          </div>
        </div>

        {/* Wave divider */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* Featured Traces */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900">Parcours populaires</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredTraces.map(trace => (
              <div
                key={trace.id}
                className="group relative bg-slate-900 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={trace.image}
                    alt={trace.titre}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>

                  {/* Badges */}
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold text-white ${getDifficultyColor(trace.difficulte)}`}>
                      {getDifficultyLabel(trace.difficulte)}
                    </span>
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${trace.type === 'route' ? 'bg-blue-500 text-white' : 'bg-amber-600 text-white'}`}>
                      {trace.type === 'route' ? 'Route' : 'Gravel'}
                    </span>
                  </div>

                  {/* Featured badge */}
                  <div className="absolute top-4 right-4">
                    <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      Top
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5 text-white">
                  <h3 className="font-bold text-xl mb-2">{trace.titre}</h3>

                  {/* Stats */}
                  <div className="flex items-center gap-4 text-slate-400 text-sm mb-4">
                    <span className="flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                      {trace.distance}
                    </span>
                    <span className="flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                      </svg>
                      {trace.denivele}
                    </span>
                    <span className="flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {trace.duree}
                    </span>
                  </div>

                  <p className="text-slate-400 text-sm mb-4 line-clamp-2">{trace.description}</p>

                  {/* Actions */}
                  <div className="flex gap-2">
                    <a
                      href={trace.stravaUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white py-2.5 rounded-lg font-medium transition-colors"
                    >
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
                      </svg>
                      Strava
                    </a>
                    <button className="flex items-center justify-center gap-2 bg-slate-700 hover:bg-slate-600 text-white px-4 py-2.5 rounded-lg font-medium transition-colors">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                      GPX
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-12">
            Comment utiliser nos traces GPX ?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-500">1</span>
              </div>
              <h3 className="font-bold text-lg mb-2">Choisissez</h3>
              <p className="text-slate-600 text-sm">Parcourez nos traces et trouvez celle qui correspond à votre niveau et vos envies.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-500">2</span>
              </div>
              <h3 className="font-bold text-lg mb-2">Téléchargez</h3>
              <p className="text-slate-600 text-sm">Téléchargez le fichier GPX ou importez directement depuis Strava.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-500">3</span>
              </div>
              <h3 className="font-bold text-lg mb-2">Synchronisez</h3>
              <p className="text-slate-600 text-sm">Envoyez la trace sur votre compteur GPS (Garmin, Wahoo, Hammerhead...).</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-500">4</span>
              </div>
              <h3 className="font-bold text-lg mb-2">Roulez !</h3>
              <p className="text-slate-600 text-sm">Passez à la boutique pour le départ et profitez de votre sortie.</p>
            </div>
          </div>
        </div>
      </section>

      {/* All Traces Section */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-8">
            Tous nos itinéraires
          </h2>

          {/* Filters */}
          <div className="flex flex-wrap gap-4 mb-8">
            {/* Type filter */}
            <div className="flex bg-slate-100 rounded-lg p-1">
              <button
                onClick={() => setActiveFilter('all')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeFilter === 'all' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'
                  }`}
              >
                Tous
              </button>
              <button
                onClick={() => setActiveFilter('route')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${activeFilter === 'route' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'
                  }`}
              >
                <img src="/type velo loc/premium.png" alt="Route" className="w-5 h-5 object-contain" />
                Route
              </button>
              <button
                onClick={() => setActiveFilter('gravel')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${activeFilter === 'gravel' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'
                  }`}
              >
                <img src="/type velo loc/gravel.png" alt="Gravel" className="w-5 h-5 object-contain" />
                Gravel
              </button>
            </div>

            {/* Difficulty filter */}
            <select
              value={difficultyFilter}
              onChange={(e) => setDifficultyFilter(e.target.value)}
              className="px-4 py-2 bg-slate-100 rounded-lg text-sm font-medium text-slate-700 border-0 focus:ring-2 focus:ring-orange-500"
            >
              <option value="all">Toutes difficultés</option>
              <option value="facile">Facile</option>
              <option value="modere">Modéré</option>
              <option value="difficile">Difficile</option>
              <option value="expert">Expert</option>
            </select>
          </div>

          {/* Traces Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filteredTraces.map(trace => (
              <div
                key={trace.id}
                className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-lg transition-all duration-300"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Image */}
                  <div className="relative w-full md:w-48 h-48 md:h-auto flex-shrink-0">
                    <img
                      src={trace.image}
                      alt={trace.titre}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20 md:bg-gradient-to-t md:from-transparent md:to-transparent"></div>

                    {/* Type badge */}
                    <div className="absolute top-3 left-3">
                      <span className={`px-2 py-1 rounded text-xs font-bold ${trace.type === 'route' ? 'bg-blue-500 text-white' : 'bg-amber-600 text-white'}`}>
                        {trace.type === 'route' ? 'ROUTE' : 'GRAVEL'}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 p-5">
                    <div className="flex items-start justify-between mb-2">
                      <h3 className="font-bold text-lg text-slate-900">{trace.titre}</h3>
                      <span className={`px-2 py-0.5 rounded text-xs font-semibold ${getDifficultyColor(trace.difficulte)} text-white`}>
                        {getDifficultyLabel(trace.difficulte)}
                      </span>
                    </div>

                    {/* Stats row */}
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500 mb-3">
                      <span className="flex items-center gap-1">
                        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                        </svg>
                        {trace.distance}
                      </span>
                      <span className="flex items-center gap-1">
                        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                        </svg>
                        {trace.denivele} D+
                      </span>
                      <span className="flex items-center gap-1">
                        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {trace.duree}
                      </span>
                    </div>

                    <p className="text-sm text-slate-500 mb-1">
                      <span className="font-medium text-slate-700">Surface :</span> {trace.surface}
                    </p>

                    {/* Expandable description */}
                    <button
                      onClick={() => setExpandedTrace(expandedTrace === trace.id ? null : trace.id)}
                      className="text-sm text-orange-500 hover:text-orange-600 font-medium flex items-center gap-1 mb-3"
                    >
                      {expandedTrace === trace.id ? 'Moins de détails' : 'Plus de détails'}
                      <svg className={`w-4 h-4 transition-transform ${expandedTrace === trace.id ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {expandedTrace === trace.id && (
                      <div className="mb-4 animate-fadeIn">
                        <p className="text-sm text-slate-600 mb-3">{trace.description}</p>
                        <div className="flex flex-wrap gap-2">
                          {trace.pointsForts.map((point, idx) => (
                            <span key={idx} className="px-2 py-1 bg-slate-100 text-slate-600 text-xs rounded-full">
                              ✨ {point}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Actions */}
                    <div className="flex gap-2">
                      <a
                        href={trace.stravaUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                      >
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
                        </svg>
                        Voir sur Strava
                      </a>
                      <button className="flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        Télécharger GPX
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredTraces.length === 0 && (
            <div className="text-center py-12">
              <svg className="w-16 h-16 text-slate-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
              </svg>
              <p className="text-slate-500">Aucune trace ne correspond à vos critères</p>
            </div>
          )}
        </div>
      </section>

      {/* Tips Section */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-slate-900 to-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-12">
            Conseils pour vos sorties
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                </svg>
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Météo</h3>
              <p className="text-slate-300 text-sm">
                Consultez la météo avant de partir. En gravel, évitez les jours de pluie pour les chemins boueux.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Sorties groupées</h3>
              <p className="text-slate-300 text-sm">
                Rejoignez nos sorties hebdomadaires le samedi matin. Rendez-vous à 8h30 à la boutique !
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Sécurité</h3>
              <p className="text-slate-300 text-sm">
                Portez toujours un casque, prévenez quelqu'un de votre parcours et emportez de quoi vous ravitailler.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            Besoin d'un vélo pour explorer ces traces ?
          </h2>
          <p className="text-slate-600 mb-8">
            Découvrez notre service de location de vélos haut de gamme, parfaits pour ces parcours.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/location"
              className="inline-flex items-center justify-center gap-2 bg-black text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-800 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Louer un vélo
            </a>
            <a
              href="/etude-posturale"
              className="inline-flex items-center justify-center gap-2 bg-slate-100 text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-200 transition-colors"
            >
              Étude posturale
            </a>
          </div>
        </div>
      </section>

      {/* Add custom CSS for animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>

      <Newsletter />
      <Footer />
    </div>
  );
};

export default TracesGPX;
